<div class="container mt-4">
  <button class="btn btn-primary mb-3" (click)="addTemplate()">Add Template</button>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Short Code</th>
        <th>Description</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let template of templates">
        <td>{{ template.MTShortCode }}</td>
        <td>{{ template.MTDescription }}</td>
        <td>
          <button class="btn btn-secondary" (click)="editProperties(template)">Edit</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
